import each from 'lodash/each';

import type { FeatureInput, ABTest } from './types';
import { getFeaturesFromCookie, getSetCookieStringFromFeatures, parseValueFromUrlOrCookie } from './utils';
import { EnabledABTests } from './ab_tests';

// List of A/B tests to apply.
const ABTests: ABTest[] = EnabledABTests;

/**
 * Determines the status (enabled/disabled) for all features.
 *
 * @param input
 */
export const getFeatureData = ({
  queryObj,
  cookieObj,
}: Pick<FeatureInput, 'queryObj' | 'cookieObj'>): {
  abTestData: Record<string, number | boolean>;
  featureCookieState: string;
} => {
  const cookieFeatureState = getFeaturesFromCookie(cookieObj);

  // Apply A/B tests.
  const abTestData: Record<string, number | boolean> = {};

  // Parse url and cookie, get the A/B test value
  each(ABTests, (abTest) => {
    let queryVal: undefined | boolean | number = undefined;

    const urlValue = queryObj[`test-${abTest.storageKey}`];
    const cookieValue = cookieFeatureState[abTest.storageKey];

    queryVal = parseValueFromUrlOrCookie(urlValue) ?? parseValueFromUrlOrCookie(cookieValue);

    if (queryVal !== undefined) {
      abTestData[abTest.storageKey] = queryVal;
    }
  });

  // Construct updated features state cookie object.
  const newFeatureCookieState: Record<string, string> = {};
  each(ABTests, (abTest) => {
    newFeatureCookieState[abTest.storageKey] = `${abTestData[abTest.storageKey]}`;
  });

  return {
    abTestData,
    // Need to merge original cookie data with newly set signup feature data,
    // since other app can set different features in the cookie.
    featureCookieState: getSetCookieStringFromFeatures({ ...cookieFeatureState, ...newFeatureCookieState }),
  };
};
